import { contentAPI, checkoutAPI, storefrontAccessToken } from '../config';
import { getCookie } from './dom';
import * as queries from '../queries/index';

const getDataOptions = (body) => {
	const fetchOptions = {
		method: 'GET',
		mode: 'cors',
		cache: 'no-cache',
	};

	const previewCode = typeof window !== 'undefined' ? getCookie(previewCode) : false;
	if (previewCode) body.previewCode = previewCode;

	if (!body.previewCode) delete body.previewCode;
	if (!body.forceCountry) delete body.forceCountry;
	if (!body.country) delete body.country;
	if (body.forceCountry && body.country) delete body.country;

	if (!body.market) delete body.market;
	if (!body.pricelist) delete body.pricelist;
	if (!body.campaignSite) delete body.campaignSite;

	if (typeof process !== 'undefined' && process.env.API) {
		fetchOptions.headers = {
			'api-authorization': process.env.API,
		};
		if (body.ip) fetchOptions.headers['x-forwarded-for'] = body.ip;
		delete body.ip;
	}

	if (body !== null && typeof body === 'object' && Object.keys(body).length > 0) {
		fetchOptions.method = 'POST';
		fetchOptions.accept = 'application/json, text/plain, */*;';
		fetchOptions.body = JSON.stringify(body);
	}

	return fetchOptions;
};

const fetchData = (path, body = {}) => {
	const encodedPath = path.split('/').map((part) => encodeURIComponent(part)).join('/');
	// debug: return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body)).then((resp) => resp.text()).then((text) => console.log('DEBUG: resp', text)).catch((err) => console.log('DEBUG: was not able to be fetched', err));
	return fetch(`${contentAPI}${encodedPath}`, getDataOptions(body)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err));
};

const getCheckoutOptions = (query, market, variables) => {
	const fetchOptions = {
		mode: 'cors',
		cache: 'no-cache',
		method: 'post',
	};

	const params = {
		query,
	};

	if (variables) params.variables = variables;
	fetchOptions.body = JSON.stringify(params);

	fetchOptions.headers = {
		'Content-Type': 'application/json',
		Accept: 'application/json',
		'X-Shopify-Storefront-Access-Token': storefrontAccessToken(market),
	};

	return fetchOptions;
};

const fetchCheckout = (query = '', market = '', variables = '') => (
	fetch(checkoutAPI(market), getCheckoutOptions(queries[query], market, variables)).then((data) => data.json()).catch((err) => console.log('DEBUG: was not able to be fetched', err))
);

const fetchSelf = async (path, token, body = {}) => {
	const encodedPath = path.split('/').filter((part) => part).map((part) => encodeURIComponent(part)).join('/');

	const fetchOptions = {
		mode: 'cors',
		cache: 'no-cache',
		method: 'POST',
		accept: 'application/json, text/plain, */*;',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ ...body, token }),
	};

	const res = await fetch(`${window.location.origin}/api/${encodedPath}`, fetchOptions);
	const contentType = res.headers.get('content-type');

	if (contentType && contentType.includes('application/json')) {
		try {
			return await res.json();
		} catch (err) {
			console.error('JSON parsing error:', err);
			return {};
		}
	} else {
		console.warn(`Unexpected response type: ${contentType}`);
		return {};
	}
};

if (typeof window !== 'undefined') window.fetchCheckout = fetchCheckout;

/*
 * Like fetchSelf but accepts a pre-built FormData (for multipart/form-data
 * submissions such as file uploads). The browser sets the Content-Type header
 * automatically, including the correct multipart boundary.
 */
const fetchSelfForm = async (path, formData) => {
	const encodedPath = path.split('/').filter((part) => part).map((part) => encodeURIComponent(part)).join('/');

	const res = await fetch(`${window.location.origin}/api/${encodedPath}`, {
		mode: 'cors',
		cache: 'no-cache',
		method: 'POST',
		body: formData,
	});

	const contentType = res.headers.get('content-type');
	if (contentType && contentType.includes('application/json')) {
		try {
			return await res.json();
		} catch (err) {
			console.error('JSON parsing error:', err);
			return {};
		}
	}
	console.warn(`Unexpected response type: ${contentType}`);
	return {};
};

export { fetchData, fetchCheckout, fetchSelf, fetchSelfForm };
